import { MibeModel } from './mibemodel.model';

export class SonicReference implements MibeModel {
  id: number;
  name: string;
  added_by_role: number;

  /**
   * Create a SonicReference.
   * @param {any} json - The JSON object with which to construct our SonicReference.
   */
  constructor(json:any) {
    this.loadWithJSON(json);
  }
  /**
   * Load a SonicReference.
   * @param {any} json - The JSON object with which to load our SonicReference.
   */
  loadWithJSON(json: any) {
    if (!json) {
      return;
    }
    this.id = json.id;
    this.name = json.name && json.name?.replace(/ {2,}/g, ' ');
    this.added_by_role = json.added_by_role;
  }
  /**
   * Returns a JSON representation of our SonicReference
   * @return {any} - The JSON representation of our SonicReference
   */
  toJSON() {
    var json: any = {
      'id': this.id,
      'name': this.name,
      'added_by_role': this.added_by_role
    };
    return json;
  }
}
